export type Testimonial = {
  quote: string;
  name: string;
  location: string;
  flag: string;
  img: string;
};

export const testimonials: Testimonial[] = [
  {
    quote:
      'I was terrified of shoulder rehabilitation. All those phases and criteria looked impossible. After day 5 with 360° I could structure my first complete protocol without help. By week 3 I was coaching athletes through full return-to-press with confidence. This system is a complete game-changer.',
    name: 'Marcus T.',
    location: 'New York · USA',
    flag: '🇺🇸',
    img: 'https://cdn.magicpatterns.com/patterns/generated-images/446f3251-c2ab-4e70-96a5-4ae67f705037.jpg',
  },
  {
    quote:
      'I managed knee injuries for 2 years frustrated because my clients kept re-injuring. I tried online courses for 6 months with no real framework. The 360° method actually works. I am now in the professional community coaching 15 clients through safe progressions.',
    name: 'Sofia L.',
    location: 'Toronto · Canada',
    flag: '🇨🇦',
    img: 'https://cdn.magicpatterns.com/patterns/generated-images/1c849cb6-ce02-4ea3-8ff6-703bb9838b0a.jpg',
  },
  {
    quote:
      "I was afraid I was not “good enough” to manage complex injuries. 360° proved me wrong. The visual method makes everything so clear. I felt confident from DAY ONE, which kept me motivated. I recommend it to every trainer and therapist I know.",
    name: 'David P.',
    location: 'Melbourne · Australia',
    flag: '🇦🇺',
    img: 'https://cdn.magicpatterns.com/patterns/generated-images/93ac70bf-c2d6-40f4-88a9-45ef4e1151b3.jpg',
  },
];

export const moreTestimonials: Testimonial[] = [
  {
    quote:
      'The tracking sheets live on my desk now. I assess clients on Monday and I already know which exercises to assign before they leave. I manage 8 injured athletes confidently now.',
    name: 'James R.',
    location: 'Toronto · Canada',
    flag: '🇨🇦',
    img: 'https://cdn.magicpatterns.com/patterns/generated-images/c526c1e2-04f3-4c22-a9c8-0055054da7bb.jpg',
  },
  {
    quote:
      'The Spine & Core Shield did it in three days. I had tried YouTube protocols for six months and always felt lost. Seeing the assessment criteria explained visually finally made clinical sense.',
    name: 'Emma T.',
    location: 'London · UK',
    flag: '🇬🇧',
    img: 'https://cdn.magicpatterns.com/patterns/generated-images/b6aa30ac-0d6f-4985-bab2-9562a89af3f4.jpg',
  },
  {
    quote:
      'The 6-volume calendar is what kept me consistent. 30 minutes a day learning one protocol, no guessing what to study. Week 4 I returned my first athlete to heavy lifting safely.',
    name: 'Luis M.',
    location: 'California · USA',
    flag: '🇺🇸',
    img: 'https://cdn.magicpatterns.com/patterns/generated-images/439d2969-5008-43e0-bf29-219167ce8711.jpg',
  },
  {
    quote:
      'I bought it for the shoulder protocols and stayed for the professional community. The Discord has elite therapists who review your case planning. Worth far more than $27.',
    name: 'Rachel P.',
    location: 'Auckland · New Zealand',
    flag: '🇳🇿',
    img: 'https://cdn.magicpatterns.com/patterns/generated-images/f1478b2d-b30d-4ee0-9463-220771da6153.jpg',
  },
];
